import {useEffect, useRef, useState} from "react";

export default function Pagination(props) {
    const [p, setP] = useState([])
    const pagesMaxLength = 5;

    useEffect(() => {
        getPages();
    }, [props]);

    function getPages() {
        let pages = [];

        if (props.pagesCount <= pagesMaxLength) {
            for (let i =1; i <= props.pagesCount; i++ ) {
                pages[i] = {val: i, active: false};
            }
        } else {
            if ((props.pagesCount - props.currentPage) < pagesMaxLength - 2) {
                pages[1] = {val: 1, active: false};
                let endPages = pagesMaxLength - 1;
                let i = 2;
                while (endPages) {
                    pages[i] = {val: props.pagesCount - endPages + 1, active: false};
                    i++
                    endPages--;
                }
            } else if (props.currentPage === 1) {
                for (let i = 1; i < pagesMaxLength; i++) {
                    pages[i] = {val: i, active: false};
                }
                pages[pagesMaxLength] = {val: props.pagesCount, active: false};
            } else {
                pages[1] = {val: 1, active: false};

                let fromPage = props.currentPage !== 2 ? props.currentPage - 1 : props.currentPage;

                for (let i= 2; i < pagesMaxLength; i++) {
                    pages[i] = {val: fromPage, active: false};
                    fromPage++;
                }
                pages[pagesMaxLength] = {val: props.pagesCount, active: false};
            }
        }

        let i = 1;
        while (pages[i]) {
            if (pages[i].val === props.currentPage) pages[i].active = true;
            i++;
        }

        setP(pages)
    }

    function setPageHandler(e) {
        props.setPageHandler(Number(e.target.innerHTML))
    }

    function pageUpHandler() {
        if (props.currentPage < props.pagesCount)
            props.setPageHandler(Number(props.currentPage + 1))
    }

    function pageDownHandler() {
        if (props.currentPage - 1 > 0) {
            props.setPageHandler(Number(props.currentPage - 1))
        }
    }

    let pageItems = p.map((item, index) =>
        <li onClick={setPageHandler} className="page-item hover" key={index}><span className={item.active ? "page-link active" : "page-link"} >{item.val}</span></li>
    )

    return (
        <>
            <ul className="pagination" style={{display: props.pagesCount > 1 ? '' : 'none'}}>
            <li className="page-item hover" onClick={pageDownHandler}>
                    <span className="page-link" aria-label="Предыдущая">
                        <span aria-hidden="true">&laquo;</span>
                    </span>
                </li>
                {pageItems}
                <li className="page-item hover" onClick={pageUpHandler}>
                    <span className="page-link" aria-label="Следующая">
                        <span aria-hidden="true">&raquo;</span>
                    </span>
                </li>
            </ul>
        </>
    )
}